::ng-deep lib-create-flow-template-dialog mat-dialog-content{min-height:200px}
/*# sourceMappingURL=create-eat-workflow-dialog.component-W6QNO2HO.css.map */
